
      import API from "!../../../../sales-app-extensions/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../sales-app-extensions/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../sales-app-extensions/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../sales-app-extensions/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../sales-app-extensions/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../sales-app-extensions/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../sales-app-extensions/node_modules/css-loader/dist/cjs.js!../../../../../node_modules/less-loader/dist/cjs.js!./main.less";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../sales-app-extensions/node_modules/css-loader/dist/cjs.js!../../../../../node_modules/less-loader/dist/cjs.js!./main.less";
       export default content && content.locals ? content.locals : undefined;
